<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <article>
        <h2>회원가입</h2>
        <ul class="breadCrumb">
          <li class="home"></li>
          <li>
            <p class="pageTxt">회원가입(일반)</p>
            <ul class="depth">
              <li><router-link to="/membershipagreement" title="회원가입(일반)">회원가입(일반)</router-link></li>
              <li><router-link to="/businessagreement" title="회원가입(사업자)">회원가입(사업자)</router-link></li>
            </ul>
          </li>
        </ul>
      </article>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <!--stepArea-->
        <div class="stepArea web">
          <ul>
            <li class="on">
              <span>1</span>
              <p>이용약관 확인 및 동의</p>
            </li>
            <li>
              <span>2</span>
              <p>본인인증</p>
            </li>
            <li>
              <span>3</span>
              <p>정보입력</p>
            </li>
            <li>
              <span>4</span>
              <p>회원가입 신청완료</p>
            </li>
          </ul>
        </div>
        <div class="stepArea mobile">
          <ul>
            <li class="on">
              <span>1</span>
              <p>이용약관 확인 및 동의</p>
            </li>
            <li>
              <span>2</span>
              <p>본인인증</p>
            </li>
            <li>
              <span>4</span>
              <p>회원가입 신청완료</p>
            </li>
            <li>
              <span>3</span>
              <p>정보입력</p>
            </li>
          </ul>
        </div>
        <!--//stepArea-->
        <!--privacyArea-->
        <article class="privacyArea">
          <article class="privacyHead">
            <p class="tit">이용약관 확인 및 동의</p>
            <p class="checkbox btnCheck">
              <input
                type="checkbox"
                id="chk-on1"
                class="hidden"
                v-model="allCheck"
                @click="checkAll"
                @change="checkboxCkc()"
              />
              <label for="chk-on1" class="btn checkBtn">전체동의</label>
            </p>
          </article>

          <article>
            <Accordion class="accordion type01">
              <template #title> 개인정보 이용동의 </template>
              <template #cont>
                이천시시설관리공단은 법령에 따른 개인정보 보유·이용 기간 또는 정보주체로부터 개인정보를 수집 시 동의
                받은 개인정보 보유·이용기간 내에서 개인정보를 처리합니다. 각각의 개인정보 처리 및 보유 기간은 다음과
                같습니다. 가. 홈페이지 회원 가입 및 관리: 홈페이지 탈퇴시까지 다만, 다음의 사유에 해당하는 경우에는 해당
                사유 종료시까지 1) 관계 법령 위반에 따른 수사·조사 등이 진행중인 경우에는 해당 수사, 조사 종료시까지 2)
                홈페이지 이용에 따른 채권, 채무관계 잔존시에는 해당 채권, 채무관계 정산시까지 3) 3년 이상 미 접속 고객일
                경우 개인정보 파기 4) 공단 홈페이지에서 운영하는 게시판에 본인확인을 통하여 작성된 글의 경우 게시글 삭제
                시 즉시 파기 나. 민원사무 처리: 민원처리 종료 후 3년 다. 이천농업테마공원 숙박이용자명단,
                이천농업테마공원 체험예약현황: 3년 라. 공영주차장 주차요금 관리대장, 공영주차장 월정기권 이용자 명부,
                공영주차장 월정기권 차량변경 신청 관리대장, 공영주차장 월정기권 과오납/환급 신청 관리대장,
                이천농업테마공원 대관허가 신청 관리대장: 5년 마. 납골당 및 공설 공원묘지 봉안관리대장, 자연장 관리대장,
                이천시 교통약자 이동지원센터 심사승인처리부, 이천시 교통약자 이동지원센터 이용 대상자 관리, 이천시
                교통약자 이동지원센터 요청서: 준영구
              </template>
            </Accordion>
            <p class="checkbox">
              <input type="checkbox" id="chk-on2" class="hidden" v-model="check1" @change="checkboxCkc()" />
              <label for="chk-on2" class="btn"
                >위의 개인정보 수집·이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 즉시감면
                서비스를 이용할 수 없습니다.</label
              >
            </p>
          </article>

          <article>
            <Accordion class="accordion type01">
              <template #title> 개인정보처리방침안내 </template>
              <template #cont>
                이천시시설관리공단(이하‘공단’)이 운영‧관리하는 공영주차장 홈페이지는 「개인정보보호법」에 따라 이용자의
                개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은
                처리방침을 수립‧공개합니다. 제1조 (개인정보의 처리목적) ‘이천시시설관리공단 주차포털 홈페이지’는 다음의
                목적을 위해 개인정보를 처리합니다. 처리한 개인정보는 다음의 목적 이외의 용도로는 사용되지 않으며, 이용
                목적 등이 변경될 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할
                예정입니다. 1. 홈페이지 회원가입 및 관리 회원가입 및 회원제 서비스 제공에 따른 제한적 본인 식별‧인증,
                회원자격 유지‧관리에 따른 본인확인, 개인식별, 부정이용방지, 비인가 사용방지, 가입의사 확인, 만14세 미만
                아동 개인정보 수집 시 법정대리인 동의 여부 확인, 각종 고지‧통지, 고충처리 등을 목적으로 개인정보를
                처리합니다. 2. 민원사무 처리 민원인의 신원 확인, 민원사항, 사실조사를 위한 연락, 통지, 처리결과 통보
                등의 목적으로 개인정보를 처리합니다. 3. 개인정보의 수집 및 이용목적 서비스 제공에 관한 계약 이행 및
                서비스 제공에 따른 요금정산 컨텐츠 제공, 구매 및 요금결제, 회원관리 회원제 서비스 이용에 따른 본인 확인,
                개인식별, 가입의사확인개인정보를 처리합니다. 4. 영상정보처리기기 정보 시설안전 및 화재예방 등을 목적으로
                개인정보를 처리합니다. 5. 개인정보 파일 가. 개인정보 파일명 : 이천시시설관리공단 공영주차장 회원정보 나.
                개인정보 항목 : 차량번호, 핸드폰번호, 차종, 이름, 계좌번호, 주소 다. 수집방법 : 홈페이지, 서면양식, 전화
                라. 보유근거 : 정보주체의 동의 마. 보유기간 : 보유목적 달성 시 제2조 (개인정보의 처리 및 보유기간) 1.
                이천시시설관리공단 주차포털 홈페이지’는 법령에 따른 개인정보 보유‧이용기간 또는 정보주체로부터
                개인정보를 수집시에 동의 받은 개인정보 보유, 이용기간 내에서 개인정보를 처리, 보유합니다. 제3조
                (개인정보의 제3자 제공에 관한 사항) 1. 이천시시설관리공단 공영주차장은 개인정보를 제1조(개인정보의 처리
                목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」
                제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다. 제4조 (개인정보처리 위탁) 1.
                공사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다. 가. 홈페이지
                유지관리 - 위탁받는 자 (수탁자) : ㈜대흥정보 - 위탁하는 업무 : 홈페이지 유지관리 - 연 락 처 : - 위탁기간
                : 2. 홈페이지 회원가입 및 관리 ‘공단’은 위탁계약 체결 시 개인정보 보호법 제25조에 따라 위탁업무 수행목적
                외 개인정보 처리금지, 기술적-관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리-감독, 손해배상 등 책임에
                관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다. 3.
                위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록
                하겠습니다. 제5조 (정보주체와 법정대리인의 권리‧의무 및 그 행사 방법) 1. 정보주체는 이천시시설관리공단에
                대해 언제든지 개인정보 열람‧정정‧삭제‧처리정지 요구 등의 권리를 행사할 수 있습니다. 2. 제1항에 따른 권리
                행사는 이천시시설관리공단에 대해 「개인정보 보호법」 시행령 제41조에 따라 서면, 전자우편, 모사전송(FAX)
                등을 통하여 하실 수 있으며 이천시시설관리공단 공영주차장은 이에 대해 지체 없이 조치하겠습니다. 3.
                제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다.
                이 경우 “개인정보 처리 방법에 관한 고시(제2020-7호)” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
                4. 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의
                권리가 제한 될 수 있습니다. 5. 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로
                명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다. 6. 이천시시설관리공단 공영주차장은 정보주체 권리에
                따른 열람의 요구, 정정‧삭제의 요구, 처리정지의 요구시 열람 등 요구를 한 자가 본인이거나 정당한
                대리인인지를 확인합니다. 제6조 (처리하는 개인정보의 항목 작성) 1. 이천시시설관리공단 주차포털 홈페이지는
                다음의 개인정보 항목을 처리하고 있습니다. 가. 처리정보 :홈페이지 회원가입 및 관리> 나. 필수항목 : 이름,
                차량번호, 휴대전화번호 다. 선택항목 : 주소, 계좌번호, 차량종류, 감면정보 제7조 (개인정보의 파기) 1.
                이천시시설관리공단 주차포털 홈페이지는 원칙적으로 개인정보 처리목적의 달성 등 개인정보가 불필요하게
                되었을 때는 지체 없이 해당 개인정보를 파기합니다. 2. 개인정보 파기의 절차 및 방법은 다음과 같습니다. 가.
                파기절차: 이천시시설관리공단은 파기하여야 하는 개인정보(또는 개인정보파일)에 대해 개인정보 파기계획을
                수립하여 파기합니다. 파기사유가 발생한 개인정보(또는 개인정보파일)을 선정하고, 개인정보 보호책임자의
                승인을 받아 개인정보(또는 개인정보파일)를 파기합니다. 나. 파기기한 및 방법: 이천시시설관리공단은 전자적
                파일 형태로 기록‧저장된 이용자의 개인정보는 개인정보 보존기간이 경과되거나, 개인정보의 처리 목적 달성,
                해당 서비스의 폐지 등 개인정보가 불필요하게 되었을 때 기록을 재생할 수 없는 기술적 방법을 사용합니다.
                종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다. 제8조 (개인정보의 안전성 확보
                조치) 이천시시설관리공단은 「개인정보보호법」 제29조에 따라 안정성 확보에 필요한 기술적/관리적 및 물리적
                조치를 취하고 있습니다. 1. 개인정보 취급 직원의 최소화 및 교육 개인정보를 취급하는 직원을 지정하고
                담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을 시행하고 있습니다. 2. 내부관리계획의 수립 및
                시행 개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다. 3. 기술적 대책 개인정보
                유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신‧점검을 하며 외부로부터 접근이 통제된
                구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다. 제9조 (개인정보 보호책임자) 1.
                이천시시설관리공단 주차포털 홈페이지는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와
                관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
                ▶ 개인정보 보호 책임자 ∙ 책임자 : 박태훈 ∙ 직책 : 팀장 ∙ 연락처 : 070-4496-1822 ▶ 개인정보 보호 담당자 ∙
                부서명 : 공공사업팀 ∙ 담당자 : 이금순 주임∙ 연락처 : 070-4496-1824 2. 정보주체께서는 이천시시설관리공단
                주차포털 홈페이지를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한
                사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 이천시시설관리공단 주차포털 홈페이지는
                정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다. 제10조 (개인정보 열람청구) 1. 정보주체는
                「개인정보 보호법」 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다.
                이천시시설관리공단 주차포털 홈페이지는 정보주체의 개인정보 열람청구가 신속하게 처리되도록
                노력하겠습니다. ▶ 개인정보 열람청구 접수‧처리 부서 ∙ 부서명 : 공공사업팀 ∙ 담당자 : 이금순 ∙ 연락처 :
                070-4496-1824 제11조 (권익침해 구제방법) 1. 개인정보 주체는 개인정보침해로 인한 구제를 받기 위하여
                개인정보분쟁조정위원회, 한국인터넷진흥원, 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수
                있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하여 주시기 바랍니다. 가.
                개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr) 나. 개인정보침해신고센터 : (국번없이)
                118 (privacy.kisa.or.kr) 다. 대검찰정 : (국번없이) 1301 (www.spo.go.kr) 라. 경찰청 : (국번없이) 182
                (ecrm.cyber.go.kr) 2. 개인정보의 열람, 정정‧삭제, 처리정지 등에 대한 정보 주체자의 요구에 대하여
                공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익을 침해 받은 자는 행정심판법이 정하는 바에
                따라 행정심판을 청구할 수 있습니다. 가. 행정심판 청구 : 중앙행정심판위원회 - 소관업무 : 개인정보
                침해사실 신고, 상담신청, 자료제공 - 홈페이지 : www.simpan.go.kr 제12조 (영상정보처리기기 설치‧운영)
                이천시시설관리공단 주차포털 홈페이지는 아래와 같이 영상정보처리기기를 설치‧운영하고 있습니다. 1.
                영상정보처리기기 설치근거‧목적 ∙ 개인정보보호법 제25조 제1항에 따라 다음과 같은 목적으로
                영상정보처리기기를 설치‧운영합니다. 가. 법령에서 구체적으로 허용하고 있는 경우 나. 범죄의 예방 및 수사를
                위하여 필요한 경우 다. 시설안전 및 화재 예방을 위하여 필요한 경우 라. 교통단속을 위하여 필요한 경우 마.
                교통정보의 수집‧분석 및 제공을 위하여 필요한 경우 제13조 (개인정보 처리방침의 변경) 1. 이
                개인정보처리방침은 2023년 3월 0일부터 적용됩니다.
              </template>
            </Accordion>
            <p class="checkbox">
              <input type="checkbox" id="chk-on3" class="hidden" v-model="check2" @change="checkboxCkc()" />
              <label for="chk-on3" class="btn">개인정보 수집 및 이용안내를 숙지하였습니다.</label>
            </p>
          </article>

          <article>
            <Accordion class="accordion type01">
              <template #title> 이천시 공영주차포털 이용약관 </template>
              <template #cont>
                제1조 (목적) 본 약관은 이천시시설관리공단 공영주차장 홈페이지(이하 “공단”)가 제공하는 모든 서비스(이하
                “서비스”)의 이용조건 및 절차, 이용자와 당 홈페이지의 권리, 의무, 책임사항과 기타 필요한 사항을 규정함을
                목적으로 합니다. 제2조 (약관의 명시와 개정) 1. 이용자가 본 약관 내용에 동의하는 경우, 홈페이지의 서비스
                제공 행위 및 이용자의 서비스 사용 행위에 본 약관이 우선적으로 적용됩니다. 2. 홈페이지는 약관의 규제에
                관한법률, 전자거래기본법, 전자서명법, 정보통신 이용촉진 및 정보보호이용 등에 관한법률, 방문판매 등에
                관한법률 소비자보호법등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다. 3. 홈페이지는
                귀하가 본 약관 내용에 동의하는 것을 조건으로 귀하에게 서비스를 제공할 것이며, 귀하가 본 약관의 내용에
                동의하는 경우, 홈페이지의 서비스 제공 행위 및 귀하의 서비스 사용행위에는 본 약관이 우선적으로 적용될
                것입니다. 4. 이 약관에 동의하는 것은 정기적으로 웹을 방문하여 약관의 변경사항을 확인하는 것에 동의함을
                의미합니다. 변경된 약관에 대한 정보를 알지 못해 발생하는 이용자의 피해는 홈페이지에서 책임지지 않습니다.
                제3조 (약관 외 준칙) 본 약관에 명시되지 않은 사항은 전기통신기본법, 전기통신사업법, 방송통신심의위원회
                정보통신에 관한 심의규정, 저작권법 및 기타 관계 법령의 규정에 의합니다. 제4조 (용어의 정의) 본 약관에서
                사용하는 용어의 정의는 다음과 같습니다. 1. 이용자 : 본 약관에 따라 홈페이지가 제공하는 서비스를 받는
                자를 말합니다. 2. 신 청 : 홈페이지가 제공하는 신청서 양식에 해당 정보를 기입하고, 본 약관에 동의하여
                서비스 이용계약을 완료시키는 행위를 말합니다. 3. 회 원 : 홈페이지에 회원가입에 필요한 개인정보를
                제공하여 회원 등록을 한 자로서, 홈페이지의 정보 및 서비스를 이용할 수 있는 자를 말합니다. 4. 정기권 :
                홈페이지에서 정기권을 신청하여 일정기간 이용자가 사용할 수 있는 권리를 말합니다. 5. 사업자(법인,
                개인)차량 : 법인 명의로 등록(소유) 및 개인 사업자 명의로 등록한 차량 제5조 (이용 계약의 성립) 1.
                이용계약은 신청자가 온라인으로 홈페이지에서 제공하는 소정의 가입신청양식을 작성하여 신청을 완료하는
                것으로 성립됩니다. 2. 본 이용약관에 대한 동의는 이용신청 당시 해당 당 사이트의 ‘동의합니다’ 버튼을
                누름으로써 의사표시를 합니다. 3. 당 홈페이지는 다음 각 항에 해당하는 경우 그 사유가 해소될 때까지
                이용계약 성립을 유보할 수 있습니다. 가. 서비스 관련 제반 용량이 부족한 경우 나. 기술상 장애 사유가 있는
                경우 제6조 (회원정보 사용에 대한 동의) 1. 회원의 개인정보는 공공기관의 개인정보보호에 관한 법률에 의해
                보호됩니다. 2. 정기권 가입 정보는 다음과 같이 수집, 사용, 관리, 보호됩니다. 가. 개인정보의 수집 :
                홈페이지는 홈페이지 서비스 가입 시 회원이 제공하는 정보를 통하여 회원의 정보를 수집합니다. 나.
                개인정보의 사용 : 홈페이지는 홈페이지 서비스 제공과 관련해서 수집된 회원의 신상정보를 본인의 승낙 없이
                제3자에게 누설, 배포하지 않습니다. 단, 전기통신기본법 등 법률의 규정에 의해 국가기관의 요구가 있는 경우,
                범죄에 대한 수사상의 목적이 있거나 정보통신윤리위원회의 요청이 있는 경우 또는 기타 관계법령에서 정한
                절차에 따른 요청이 있는 경우, 회원이 홈페이지에 제공한 개인정보를 스스로 공개한 경우에는 그러하지
                않습니다. 다. 개인정보의 관리 : 개인정보의 보호 및 관리를 위하여 서비스의 개인정보관리에서 수시로 회원의
                개인정보를 수정/삭제할 수 있습니다. 수신되는 정보 중 불필요하다고 생각되는 부분도 변경‧조정할 수
                있습니다. 라. 개인정보의 보호 : 회원의 개인정보는 오직 회원만이 열람/수정/삭제 할 수 있으며, 이는
                전적으로 회원 본인의 가입정보에 의해 관리되고 있습니다. 따라서 타인에게 회원의 가입정보를 알려주어서는
                아니되며, 작업 종료시에는 반드시 로그아웃 하고, 웹 브라우저의 창을 닫아야합니다.(이는 타인과 컴퓨터를
                공유하는 공공장소에서 컴퓨터를 사용하는 경우에 귀하의 정보보호를 위하여 필요한 사항입니다) 3. 홈페이지에
                본 약관에 따라 이용신청을 하는 것은 홈페이지가 본 약관에 따라 신청서에 기재된 회원정보를 수집, 이용하는
                것에 동의하는 것으로 간주됩니다. 제7조 (사용자의 정보 보안) 1. 홈페이지 서비스 가입 절차를 완료하는
                순간부터 회원은 입력한 정보의 비밀을 유지할 책임이 있으며, 가입정보를 사용하여 발생하는 모든 결과에 대한
                책임은 회원 본인에게 있습니다. 2. 가입정보에 관한 모든 관리의 책임은 회원 본인에게 있으며, 가입정보가
                부정하게 사용되었다는 사실을 발견한 경우에는 관리자에게 신고하여야 합니다. 신고를 하지 않음으로 인해
                발생하는 모든 책임은 회원 본인에게 있습니다. 3. 이용자는 홈페이지 서비스의 사용 종료 시마다 정확히
                로그아웃(Log-out)해야하며, 로그아웃하지 아니하여 제3자가 귀하에 관한 정보를 도용하는 등의 결과로 인해
                발생하는 손해 및 손실에 대하여 홈페이지는 책임을 부담하지 아니합니다. 제8조 (서비스 이용시간) 1. 서비스
                이용시간은 홈페이지의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간을 원칙으로 합니다.
                2. 제1항의 이용시간 중 정기점검 등의 필요로 인하여 홈페이지가 정한 날 또는 시간은 예외로 합니다. 제9조
                (서비스의 중지에 대한 공지) 1. 홈페이지 서비스에 보관되거나 전송된 메시지 및 기타 통신 메시지 등의
                내용이 국가의 비상사태, 정전, 홈페이지의 관리 범위 외의 서비스 설비 장애 및 기타 불가항력에 의하여
                보관되지 못하였거나 삭제된 경우, 전송되지 못한 경우 및 기타 통신 데이터의 손실이 있을 경우에 홈페이지는
                관련 책임을 부담하지 아니합니다. 2. 공사가 정상적인 서비스 제공의 어려움으로 인하여 일시적으로 서비스를
                중지하여야 할 경우에는 서비스 중지 1주일 전에 홈페이지에 서비스 중지사유 및 일시를 공지한 후 서비스를
                중지할 수 있으며, 이 기간 동안 회원이 공지내용을 인지하지 못한 데 대하여 홈페이지는 책임을 부담하지
                아니합니다. 부득이한 사정이 있을 경우 위 사전 공지기간은 감축되거나 생략될 수 있습니다. 또한 위 서비스
                중지에 의하여 본 서비스에 보관되거나 전송된 메시지 및 기타 통신 메시지 등의 내용이 보관되지 못하였거나
                삭제된 경우, 전송되지 못한 경우 및 기타 통신 데이터의 손실이 있을 경우에 대하여도 홈페이지는 책임을
                부담하지 아니합니다. 3. 공사의 사정으로 서비스를 영구적으로 중단하여야 할 경우에는 제2항에 의거합니다.
                다만, 이 경우 사전 공지기간은 1개월로 합니다. 4. 공단은 사전 공지 후 서비스를 일시적으로 수정, 변경 및
                중단할 수 있으며, 이에 대하여 회원 또는 제3자에게 어떠한 책임도 부담하지 아니합니다. 5. 공단은 긴급한
                시스템 점검, 증설 및 교체 등 부득이한 사유로 인하여 예고 없이 일시적으로 서비스를 중단할 수 있으며,
                새로운 서비스로의 교체 등 홈페이지가 적절하다고 판단하는 사유에 의하여 현재 제공되는 서비스를 완전히
                중단할 수 있습니다. 6. 홈페이지는 국가비상사태, 정전, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로
                정상적인 서비스 제공이 불가능할 경우, 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다. 다만 이
                경우 그 사유 및 기간 등을 이용자에게 사전 또는 사후에 공지합니다. 7. 공단은 홈페이지가 통제할 수 없는
                사유로 인한 서비스중단의 경우(시스템관리자의 고의, 과실 없는 디스크장애, 시스템다운 등)에 사전통지가
                불가능하며 타인(PC통신회사, 기간통신사업자 등)의 고의, 과실로 인한 시스템중단 등의 경우에는 통지하지
                않습니다. 8. 홈페이지는 서비스를 특정범위로 분할하여 각 범위별로 이용가능시간을 별도로 지정할 수
                있습니다. 다만 이 경우 그 내용을 공지합니다. 9. 홈페이지는 회원이 본 약관의 내용에 위배되는 행동을 한
                경우, 임의로 서비스 사용을 제한 및 중지하거나 회원의 동의 없이 이용계약을 해지할 수 있습니다. 이 경우
                홈페이지는 위 이용자의 접속을 금지할 수 있습니다. 제10조 (정보 제공 및 홍보물 게재) 1. 공단은 서비스를
                운영함에 있어서 각종 정보를 홈페이지에 게재하는 방법, 전자우편이나 서신우편 발송 등으로 귀하에게 제공할
                수 있습니다. 2. 공단은 서비스에 적절하다고 판단되거나 공익성이 있는 홍보물을 게재할 수 있습니다. 제11조
                (홈페이지 게시물의 관리, 운영) 1. 회원이 게시한 게시물의 내용에 대한 권리는 회원에게 있습니다. 2. 공단은
                게시된 내용을 사전 통지 없이 편집, 이동할 수 있는 권리를 보유하며, 다음의 경우 사전 통지 없이 삭제할 수
                있습니다. 가. 본 서비스 약관에 위배되거나 상용 또는 불법, 음란, 저속하다고 판단되는 게시물을 게시한 경우
                나. 다른 회원 또는 제 3자를 비방하거나 중상 모략으로 명예를 손상시키는 내용인 경우 다. 공공질서 및
                미풍양속에 위반되는 내용인 경우 라. 범죄적 행위에 결부된다고 인정되는 내용일 경우 마. 제3자의 저작권 등
                기타 권리를 침해하는 내용인 경우 바. 기타 관계 법령에 위배되는 경우 3. 회원의 게시물이 타인의 저작권을
                침해함으로써 발생하는 민, 형사상의 책임은 전적으로 회원 본인이 부담하여야 합니다. 제12조 (서비스
                이용제한) 1. 회원이 제공하는 정보의 내용이 허위인 것으로 판명되거나, 허위가 있다고 의심할만한 합리적인
                사유가 발생할 경우 홈페이지는 회원의 본 서비스 사용을 일부 또는 전부 중지할 수 있으며, 이로 인해
                발생하는 불이익에 대해 책임을 부담하지 아니합니다. 2. 홈페이지는 귀하가 본 약관의 내용에 위배되는 행동을
                한 경우, 임의로 서비스 사용을 제한 및 중지할 수 있습니다. 이 경우 홈페이지는 귀하의 접속을 금지할 수
                있습니다. 제13조 (공단의 의무) 1. 공단은 법령과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지
                않으며, 지속적, 안정적으로 서비스를 제공하기 위해 노력할 의무가 있습니다. 2. 공단은 회원의 개인 신상
                정보를 본인의 승낙 없이 타인에게 누설, 배포하지 않습니다. 다만, 전기통신관련법령 등 관계법령에 의하여
                관계 국가기관 등의 요구가 있는 경우에는 그러하지 아니합니다. 3. 공단은 이용자가 안전하게
                홈페이지서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함) 보호를 위한 보안시스템을 갖추어야
                합니다. 4. 공단은 이용자의 귀책사유로 인한 서비스 이용 장애에 대하여 책임을 지지 않습니다. 제14조
                (저작권) 1. 이용자는 홈페이지내의 서비스를 통하여 얻은 정보나 서비스에 게재된 자료를 사전 동의 없이
                가공, 손해하는 행위 등 상업적 목적으로 이용할 수 없습니다. 2. 이용자가 게시한 게시물의 내용에 대한
                권리와 책임은 이용자 본인에게 있습니다. 3. 공단은 게시된 내용을 사전 통지 없이 편집, 이동할 수 있는
                권리를 보유하며, 게시판운영원칙에 따라 사전 통지 없이 삭제할 수 있습니다. 4. 이용자의 게시물이 타인의
                저작권을 침해함으로써 발생하는 민, 형사상의 책임은 전적으로 회원 본인에게 있습니다. 제15조 (당
                홈페이지의 소유권) 1. 당 홈페이지가 제공하는 서비스, 그에 필요한 소프트웨어, 이미지, 마크, 로고, 디자인,
                서비스명칭, 정보 및 상표 등과 관련된 지적재산권 및 기타 권리는 공단에 소유권이 있습니다. 2. 당
                홈페이지가 명시적으로 승인한 경우를 제외하고는 전항의 소정의 각 재산에 대한 전부 또는 일부의 수정, 대여,
                대출, 판매, 배포, 제작, 양도, 재라이센스, 담보권 설정 행위, 상업적 이용 행위를 할 수 없으며, 제3자로
                하여금 이와 같은 행위를 하도록 허락할 수 없습니다. 제16조 (양도금지) 1. 회원이 서비스의 이용권한, 기타
                이용계약 상 지위를 타인에게 양도, 증여할 수 없으며, 이를 담보로 제공할 수 없습니다. 제17조 (손해배상) 1.
                당 홈페이지는 무료로 제공되는 서비스와 관련하여 회원에게 어떠한 손해가 발생하더라도 홈페이지가 고의로
                행한 범죄행위를 제외하고는 이에 대하여 책임을 부담하지 아니합니다. 제18조 (면책조항) 1. 공단은 천재지변,
                전쟁 및 기타 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 대한 책임이
                면제됩니다. 2. 공단은 기간통신 사업자가 전기통신 서비스를 중지하거나 정상적으로 제공하지 아니하여 손해가
                발생한 경우 책임이 면제됩니다. 3. 공단은 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로
                발생한 손해에 대한 책임이 면제됩니다. 4. 공단은 이용자의 컴퓨터 오류에 의해 손해가 발생한 경우, 또는
                회원이 신상정보 및 전자우편 주소를 부실하게 기재하여 손해가 발생한 경우 책임을 지지 않습니다. 5. 공단은
                서비스에 표출된 어떠한 의견이나 정보에 대해 확신이나 대표할 의무가 없으며 회원이나 제3자에 의해 표출된
                의견을 승인하거나 반대하거나 수정하지 않습니다. 홈페이지는 어떠한 경우라도 귀하가 서비스에 담긴 정보에
                의존해 얻은 이득이나 입은 손해에 대해 책임이 없습니다. 6. 공단은 회원간 또는 회원과 제3자간에 서비스를
                매개로 하여 물품거래 혹은 금전적 거래 등과 관련하여 어떠한 책임도 부담하지 아니하고, 회원이 서비스의
                이용과 관련하여 기대하는 이익에 관하여 책임을 부담하지 않습니다. 7. 공단은 귀하가 서비스를 이용하여
                기대하는 손익이나 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않으며, 회원이 본 서비스에
                게재한 정보, 자료, 사실의 신뢰도 등 내용에 관하여는 책임을 지지 않습니다. 8. 공단은 서비스 이용과
                관련하여 회원에게 발생한 손해 중 회원의 고의, 과실에 의한 손해에 대하여 책임을 부담하지 아니합니다. 9.
                공단은 홈페이지가 제공한 서비스가 아닌 가입자 또는 기타 유관기관이 제공하는 서비스의 내용상의 정확성,
                완전성 및 질에 대하여 보장하지 않습니다. 따라서 홈페이지는 회원이 위 내용을 이용함으로 인하여 입게 된
                모든 종류의 손실이나 손해에 대하여 책임을 부담하지 아니합니다. 또한 홈페이지는 이용자가 서비스를
                이용하며 타 이용자로 인해 입게 되는 정신적 피해에 대하여 보상할 책임을 지지 않습니다. 제19조 (관할법원)
                본 서비스 이용과 관련하여 발생한 분쟁에 대해 소송이 제기될 경우 관리자의 소재지 관할 법원으로 합니다. 부
                칙 (시행일) 본 약관은 2023년 3월 0일부터 시행합니다.
              </template>
            </Accordion>
            <p class="checkbox">
              <input type="checkbox" id="chk-on4" class="hidden" v-model="check3" @change="checkboxCkc()" />
              <label for="chk-on4" class="btn">이천시 공영주차포털 이용 약관에 동의합니다.</label>
            </p>
          </article>
        </article>
        <!--//privacyArea-->
        <!--btnArea-->
        <div class="btnArea">
          <button type="button" class="btn gray" @click="NotagreeBtn">동의안함</button>
          <button type="button" class="btn blue" @click="AggreBtn">동의</button>
        </div>
        <!--//btnArea-->
      </div>
    </section>
  </main>
</template>

<script>
import Accordion from '../../../components/Accordion01.vue';

export default {
  data() {
    return {
      allCheck: false,
      check1: false,
      check2: false,
      check3: false,
    };
  },

  components: {
    Accordion,
  },

  methods: {
    NotagreeBtn() {
      this.$router.push('/loginmain');
    },

    checkboxCkc() {
      if (this.check1 == true && this.check2 == true && this.check3 == true) {
        this.allCheck = true;
        return;
      }
      this.allCheck = false;
    },

    checkAll() {
      if (this.allCheck == false) {
        this.check1 = true;
        this.check2 = true;
        this.check3 = true;
        return;
      }

      this.check1 = false;
      this.check2 = false;
      this.check3 = false;
    },

    AggreBtn() {
      if (!this.check1 || !this.check2 || !this.check3) {
        alert('약관 중 동의하지 않은 항목이 있습니다.');
        return;
      }
      this.$router.push('/membershipinfomation');
    },
  },
};
</script>
